import * as React from 'react'
import { useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClientProvider } from '@tanstack/react-query'
import { ToastContainer } from 'react-toastify'
import { queryClient } from '@/lib/react-query'
import { StudioRouter } from './routes'
import 'react-toastify/dist/ReactToastify.css'
import { AuthProvider } from '@/features/auth'
import { toastConfig } from '@/utils/toast'
import { Puff } from '@/components/ui/Loaders'
import { Tooltip } from 'react-tooltip'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useTheme } from '@/providers/theme'
import { Theme } from '@/config/app'

const ErrorFallback = () => {
  return (
    <div role="alert" className="page page--error">
      <h2>Ooops, something went wrong :( </h2>
      <button className="btn" onClick={() => window.location.assign(window.location.origin)}>
        Refresh
      </button>
    </div>
  )
}

function App() {
  const { theme } = useTheme()

  useEffect(() => {
    theme === Theme.Light ? document.body.classList.add('light') : document.body.classList.remove('light')
  }, [theme])

  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <React.Suspense
            fallback={
              <div className={'loading-overlay'}>
                <Puff />
              </div>
            }
          >
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <HelmetProvider>
                <StudioRouter />
                <Tooltip id="tooltip" />
                <ToastContainer {...toastConfig} />
              </HelmetProvider>
            </ErrorBoundary>
          </React.Suspense>
        </AuthProvider>

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </div>
  )
}

export default App
